import WCCSliderItem from "../base/base.model";

export default class WCCSliderAdaptiveItem<T> extends WCCSliderItem<T> {
    component = 'wcc-slider-item-adaptive';
}